<template>
  <div class="row">
    <div class="col-6">
      <button class="btn create-btn btn-green w-100" @click="acceptPriceAndCreateLabels">
        Accept price and create labels
      </button>
    </div>
    <!-- todo - reenable when editing assignment form is fixed -->
    <div v-if="false" class="col-2">
      <button class="btn create-btn btn-grey w-100" @click="edit">Edit</button>
    </div>
    <div class="col-6">
      <button class="btn create-btn btn-danger w-100" @click="rejectPrice">Reject price</button>
    </div>
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { notify } from '@kyvg/vue3-notification'
import { computed, type ComputedRef, defineComponent } from 'vue'
import { useRouter } from 'vue-router'
import { LABELS_CREATING_LOADER } from '@/const/LoadersNames'
import { useAccountStore } from '@/store/account'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'
import { useUiStore } from '@/store/ui'
import { CUSTOMER_ASSIGNMENTS_SINGLE_EDIT, STAFF_ASSIGNMENTS_SINGLE_EDIT } from '@/types/router'

export default defineComponent({
  name: 'ReportReleased',
  setup() {
    const accountStore = useAccountStore()
    const uiStore = useUiStore()
    const router = useRouter()
    const assignmentSummaryStore = useAssignmentSummaryStore()

    const isStaff: ComputedRef<boolean> = computed(() => accountStore.isStaff)
    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)

    const acceptPriceAndCreateLabels = () => {
      assignmentSummaryStore
        .submitReportAccept()
        .then(() => {
          uiStore.loaderShow({
            name: LABELS_CREATING_LOADER,
            data: { progress: 0 },
          })

          assignmentSummaryStore.createLabels().then(() => {
            uiStore.loaderHide()
          })
        })
        .catch((error) => {
          notify({ group: 'error', text: error.message })
        })
    }

    const edit = () => {
      const pageName = isStaff.value ? STAFF_ASSIGNMENTS_SINGLE_EDIT : CUSTOMER_ASSIGNMENTS_SINGLE_EDIT

      router.push({
        name: pageName,
        params: {
          id: assignment.value.reference,
        },
      })
    }

    const rejectPrice = () => {
      assignmentSummaryStore
        .submitReportDeny()
        .then(() => {
          notify({ group: 'success', text: 'Price has been rejected' })
        })
        .catch((error) => {
          notify({ group: 'error', text: error })
        })
    }

    return {
      acceptPriceAndCreateLabels,
      edit,
      rejectPrice,
    }
  },
})
</script>
